import {
  BankTypeEnum,
  FiservCardInterface,
  FiservCardLockedReasonsEnum,
  FiservCardStatusEnum,
} from '@common-fe/common-fe';

export { ICardReplaceDtoReasonEnum as CardReplaceReason } from '@/dtos';

export enum CardReplacementReasons {
  LOST = 'Card lost',
  STOLEN = 'Card stolen',
  NOT_RECEIVED = 'Card not received',
  DAMAGED = 'Damaged',
  DEMOGRAPHIC_CHANGE = 'Demographic change',
}

export enum CloseActionCardType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
}

export interface ChangeCardStatusMutationArgs {
  id: string;
  status: FiservCardStatusEnum;
  lockedPursesIds?: string[];
}

export interface CardsMap {
  [holderName: string]: {
    [cardStatus in FiservCardStatusEnum]: FiservCardInterface[];
  };
}

export interface ReplaceCardMutationArgs {
  id: string;
  status: FiservCardStatusEnum;
}

export interface CardResponse {
  description: string;
  id: number;
  last4?: string;
  last2?: string;
  opened_on: Date;
  mailed_on_date: string;
  mailed_on: Date;
  activated_on: Date;
  expires_on_date: string;
  pin_set: boolean;
  created_at: Date;
  modified_at: Date;
  card_status: FiservCardStatusEnum;
  card_type: BankTypeEnum;
  lock_reason: FiservCardLockedReasonsEnum;
  sequence_number: number | null;
  card_account_id: number;
  account_ids: number[];
  member_sequence_identifier: number;
  alternate_account_id: string;
  employee_unlock_forbidden?: boolean;
  token_card_id?: string;
  is_verified?: boolean;
}

export interface CardHoldersResponse {
  suffix: string;
  dependents: CardHoldersResponse[];
  id: number;
  preferred_name: string;
  middle_name: string;
  first_name: string;
  last_name: string;
  employee_id: number;
  dependent_id: null | number;
  card_holder_type: string;
  card_holder_status: string;
  grouped_cards?: {
    [cardStatus in FiservCardStatusEnum]: CardResponse[];
  };
  date_of_birth?: string;
  relationship?: string;
}

export interface RelationshipType {
  id: number;
  name: string;
}

export enum CardActivationModalType {
  Activation = 'Activation',
  Processing = 'Processing',
  Error = 'Error',
}

export interface CardActivationData {
  memberSequenceIdentifier: number;
  alternateAccountId: string;
  cardId: string;
  employeeUnlockForbidden?: boolean;
  tokenCardId?: string;
}

export interface FiservCardPurseDto {
  id: number;
  account_name: string;
  account_type: string;
  status: string;
  is_locked_by_health_plan?: boolean | null;
}
